/**
 * cover-slider/frontend.js
 * 
 * Der Cover Slider wird bis Breakpoint MD als Swiper mit Autoplay initialisiert
 * Ab MD stellen wir ein Cover mit manueller Navigation dar
 * 
 * @author jjarolim
 */

import Swiper from 'swiper'
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules'
import { getBreakpoint, watchBreakpoint } from '../../../../resources/js/frontend/breakpoint'

import 'swiper/css'
import 'swiper/css/effect-fade'

const debug = false

/**
 * Helper functions
 */

const isElement = obj => {
    try {
        // Using W3 DOM2 (works for FF, Opera and Chrome)
        return obj instanceof HTMLElement;
    } catch(e) {
        //Browsers not supporting W3 DOM2 don't have HTMLElement and
        //an exception is thrown and we end up here. Testing some
        //properties that all elements have (works on IE7)
        return (typeof obj==="object") &&
            (obj.nodeType===1) && (typeof obj.style === "object") &&
            (typeof obj.ownerDocument ==="object");
    }
}

const initializeSwiper = activeIndex => {

    const params = {

        modules: [ Autoplay, EffectFade, Navigation, Pagination ],

        // Defaults

        observer: true, // Das ist wichtig, damit der Swiper auch in Tabs funktioniert
        observeParents: true,

        autoHeight: true,
        initialSlide: activeIndex,
        slidesPerView: 1,
        speed: 1000,

        // Events

        on: {
            init: swiper => {

                const allSlides = swiper.el.querySelectorAll( '.swiper-slide' );

                for ( const i in allSlides ) {

                    const slide = allSlides[ i ];

                    if ( ! isElement( slide ) ) {
                        continue;
                    }

                    const navigation = slide.querySelector( '.cover-slider__swiper-pagination' );

                    if ( ! isElement( navigation ) ) {  
                        continue;
                    }

                    const navItems = navigation.querySelectorAll( 'li' );

                    for ( const j in navItems ) {

                        const navItem = navItems[ j ];

                        if ( ! isElement( navItem ) ) {
                            continue;
                        }
                        
                        navItem.addEventListener( 'click', e => {
                            e.preventDefault();
                            swiper.slideTo( parseInt(j), 1000, false );
                        } );

                    }

                }

            },
            autoplayTimeLeft( swiper, time, progress ) {

                const allSlides = swiper.el.querySelectorAll( '.swiper-slide' );
                const currentSlide = allSlides[ swiper.activeIndex ];
                const currentSlideProgress = currentSlide.querySelector( '.autoplay-progress__progress-bar' );

                currentSlideProgress.style.width = ( ( 1 - progress ) * 100 ) + '%';

            }
        }
    }

    /* Breakpoint related configuration */

    const breakpoint = getBreakpoint();

    if ( [ 'xs', 'sm' ].includes( breakpoint.name ) ) {

        // Swiper mit Autoplay

        params.autoplay = {
            delay: 6000,
            disableOnInteraction: false
        }

    } else {

        // Ab MD: Cover mit manueller Navigation

        params.effect = 'fade';
        params.speed = 500;

    }

    debug && console.log( 'init cover-slider', params );

    /* Initialize Cover-Slider Swiper */

    for ( const element of document.querySelectorAll( '.block__cover-slider.has-multiple-slides' ) ) {
        debug && console.log( 'init one' )
        const swiper = new Swiper( element.querySelector( '.swiper' ), params );
    }

}

watchBreakpoint( ( breakpoints ) => {

    // Festellen, ob wir den Swiper neu initialisieren müssen:
    // Müssen wir nur, wenn wir von XS/SM auf MD/LG/XL/XXL oder umgekehrt wechseln

    const hasToBeInitialized = 
        ( [ 'xs', 'sm' ].includes( breakpoints.to.name ) && [ 'md', 'lg', 'xl', 'xxl' ].includes( breakpoints.from.name ) ) ||
        ( [ 'xs', 'sm' ].includes( breakpoints.from.name ) && [ 'md', 'lg', 'xl', 'xxl' ].includes( breakpoints.to.name ) )

    // Nope: Wir müssen nicht neu initialisieren

    if ( ! hasToBeInitialized ) {
        return;
    }

    debug && console.log( 'block__cover_slider', 'destroying swiperjs instances' )

    // Alle Swiper zerstören, damit sie neu initialisiert werden können

    for ( const element of document.querySelectorAll( '.block__cover-slider' ) ) {
        const swiperElement = element.querySelector( '.swiper' );
        if ( swiperElement.swiper !== undefined ) {
            debug && console.log( 'destroy one' )
            swiperElement.swiper.destroy( true, true );
        }
    }

    // Alle Swiper neu initialisieren

    initializeSwiper( 0 );

} );


initializeSwiper(0);